export const NOT_ENOUGH_VACATION_DAYS = 'not enough vacation days';
export const DAYS_OVERLAP = 'days overlap';
export const CANT_DELETE_PROCESSED_CLAIM = 'cant delete processed claim';
export const NOT_ENOUGH_OVERTIME_DAYS = 'not enough overtime days';
export const CANT_SAVE_PAST_TIMESHEET = 'cant save past timesheet';
export const DATE_IN_CLOSED_WEEK =
  'entry date is in closed week, unable to save';
